import { useEffect, useState } from 'react';
import PageTitle from '../Components/PageTitle';
import AxiosApi from '../Helper/axios.api';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { validateAll } from "indicative/validator";
import { updateUserDetails, updateTotalCoins } from "../Action/Auth.action";
import { Tabs, Tab } from 'react-bootstrap';
import moment from 'moment';
import ascArrow from "../assets/images/sort_asc.png";
import descArrow from "../assets/images/sort_desc.png";
import Arrow from "../assets/images/select-arrow.svg";
import personIcon from "../assets/images/icon/person.png";


const iconStyle = { marginRight: "6px", fontSize: "13px" };

const PageButtons = ({ currentPage, numPages, setPage }) => {
  if (numPages <= 1) return null; // no pagination needed

  const pages = [];
  const start = Math.max(2, currentPage - 1);
  const end = Math.min(numPages - 1, currentPage + 1);

  // First page
  pages.push(
    <li key={1} className={currentPage === 1 ? "page-item active" : "page-item"} style={{ cursor: 'pointer' }}>
      <a className="page-link" onClick={() => setPage(1)}>
        1
      </a>
    </li>
  );

  // Ellipsis if gap between 1 and start
  if (start > 2) {
    pages.push(
      <li key="start-ellipsis" className="page-item disabled">
        <span className="page-link">...</span>
      </li>
    );
  }

  // Middle pages
  for (let i = start; i <= end; i++) {
    pages.push(
      <li key={i} className={currentPage === i ? "page-item active" : "page-item"} style={{ cursor: 'pointer' }}>
        <a className="page-link" onClick={() => setPage(i)}>
          {i}
        </a>
      </li>
    );
  }

  // Ellipsis if gap between end and last page
  if (end < numPages - 1) {
    pages.push(
      <li key="end-ellipsis" className="page-item disabled">
        <span className="page-link">...</span>
      </li>
    );
  }

  // Last page
  if (numPages > 1) {
    pages.push(
      <li key={numPages} className={currentPage === numPages ? "page-item active" : "page-item"} style={{ cursor: 'pointer' }}>
        <a className="page-link" onClick={() => setPage(numPages)}>
          {numPages}
        </a>
      </li>
    );
  }

  return (
    <div className="pagination-row" style={{width: "100%"}}>
      <ul className="pagination justify-content-center" style={{ paddingTop: "1%" }}>
        {pages}
      </ul>
    </div>
  );
};

const UserSearch = ({ auth, dispatch, isLoading, setIsLoading, onSelectUser }) => {
  const [query, setQuery] = useState(null);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});

  const fetchUsers = async () => {
    if (isLoading) return;

    setErrors(errors => ({ ...errors, fetch: null }));
    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user", "post",
        { user_id: auth.userDeatils.user_id, query, limit: 20 }
      );

      if (response.login === false) {
        dispatch(logout());
        navigate("/login", { replace: true });
      }
      if (!response.status) throw Error(response.message);
      setData(response.data);
    } catch (error) {
      console.error(error);
      setErrors(errors => ({ ...errors, fetch: error.message }));
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, [query]);

  return (
    <div className="form-group mt-3">
      {errors.fetch && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.fetch}</p>}
      <label className="input-group">
        <input
          className="form-control"
          type="text" value={query || ''}
          onChange={(e) => setQuery(e.target.value != '' ? e.target.value : null)}
          placeholder='Search by user ID, name or email'
        />
      </label>
      <div style={{ overflowY: 'scroll', minHeight: '10rem', height: '20vh' }} className='border rounded p-1 mb-1'>
        {data.users?.length > 0 ? (
          <>
            {data.users.map((user) => (
              <div
                key={user.user_id}
                className='border rounded p-2 my-1'
                style={{ cursor: 'pointer' }}
                onClick={() => { onSelectUser(user.user_id) }}
              >
                <code>#{user.user_id}</code> - {user.name || <i>No username</i>} - {user.email || <i>No email</i>}
              </div>
            ))}
            {data.has_more && <p><i>More options hidden</i></p>}
          </>
        ) : <p><i>No users found.</i></p>}
      </div>
    </div>
  )
};

const UserDetails = ({ auth, dispatch, isLoading, setIsLoading, doUpdate, user_id }) => {
  const [errors, setErrors] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [userBeforeEdit, setUserBeforeEdit] = useState({});

  const fetchUser = async (user_id) => {
    if (isLoading) return;

    setErrors(errors => ({ ...errors, fetch: null, form: null }));
    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/details", "post",
        { user_id: auth.userDeatils.user_id, target_user_id: user_id }
      );
      if (!response.status) throw Error(response.message);
      setUserDetails(response.data);
      setUserBeforeEdit(response.data);
    } catch (error) {
      console.error(error);
      setErrors(errors => ({ ...errors, fetch: error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user_id === null)
      setUserDetails({});
    else
      fetchUser(user_id);
  }, [doUpdate]);

  const formRules = {
    name: "required|string",
    email: "required|email",
    password: "string|min:6",
    total_coin: "required|number",
    billing_account: "email",
  };
  const formMessages = {
    "name.required": "Name is Required.",
    "email.string": "Email must be string.",
    "email.required": "Email is Required.",
    "email.email": "Please enter valid email.",
    "password.string": "Password must be String.",
    "password.min": "Password must be more then 6 character.",
    "total_coin.required": "Coins is required.",
  };
  const submitEdit = async () => {
    if (isLoading || user_id == null) return

    setIsLoading(true);
    setErrors(errors => ({ ...errors, form: null }));

    try {
      await validateAll(userDetails, formRules, formMessages);
      setErrors(errors => ({ ...errors, form: null }));
    } catch (valErrors) {
      console.error(errors);
      setErrors((errors) => ({ ...errors, form: valErrors.map(error => error.message).join("\n") }));
      setIsLoading(false);
      return
    }

    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/edit", "post",
        {
          ...userDetails,
          edit_user_id: user_id,
          user_id: auth.userDeatils.user_id,
        }
      );
      if (!response.status) throw Error(response.message);
      if (user_id === auth.userDeatils.user_id) {
        dispatch(updateUserDetails(userDetails));
        dispatch(updateTotalCoins(userDetails));
      }
      setUserBeforeEdit(userDetails);
      toast.success(response.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      console.error(error);
      setErrors(errors => ({ ...errors, form: error.message }));
    } finally {
      setIsLoading(false);
    }
  }


  return (<>
    <div className="profile-form-block" style={{ display: 'flex', flexWrap: 'wrap', gap: '.5rem', alignItems: 'stretch' }}>

      <div className='p-1 m-1 flex-grow' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          User ID
          <input
            className='form-control w-full'
            type="text"
            name="user_id"
            disabled
            invalid={errors.user_id}
            value={userDetails.user_id || ''}
          />
        </label>
        {errors.user_id && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.user_id}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Name {userDetails.name !== userBeforeEdit.name && <span>(original value: <i>{userBeforeEdit.name}</i>)</span>}
          <input
            className='form-control'
            type="text"
            name="name"
            invalid={errors.name}
            value={userDetails.name || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: e.target.value }))}
          />
        </label>
        {errors.name && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.name}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Email {userDetails.email !== userBeforeEdit.email && <span>(original value: <i>{userBeforeEdit.email}</i>)</span>}
          <input
            className='form-control'
            type="email"
            name="email"
            invalid={errors.email}
            value={userDetails.email || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: e.target.value }))}
          />
        </label>
        {errors.email && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.email}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Website {userDetails.website !== userBeforeEdit.website && <span>(original value: <i>{userBeforeEdit.website}</i>)</span>}
          <input
            className='form-control'
            type="text"
            name="website"
            invalid={errors.website}
            value={userDetails.website || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: e.target.value }))}
          />
        </label>
        {errors.website && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.website}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Set new Password
          <input
            className='form-control'
            type="password"
            name="password"
            invalid={errors.password}
            value={userDetails.password || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: e.target.value }))}
          />
        </label>
        {errors.password && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.password}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Coins {userDetails.total_coin !== userBeforeEdit.total_coin && <span>(original value: <i>{userBeforeEdit.total_coin}</i>)</span>}
          <input
            className='form-control'
            type="number"
            name="total_coin"
            invalid={errors.total_coin}
            value={userDetails.total_coin || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: parseInt(e.target.value) }))}
          />
        </label>
        {errors.total_coin && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.total_coin}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }} onClick={() => setUserDetails((userDetails) => ({ ...userDetails, is_active: !userDetails.is_active }))}>
          Is Active {userDetails.is_active !== userBeforeEdit.is_active && <span>(original value: <i>{userBeforeEdit.is_active ? 'Yes' : 'No'}</i>)</span>}<br />
          <input
            className='form-control'
            type="text"
            readOnly
            invalid={errors.is_active}
            value={userDetails.is_active ? 'Yes' : 'No'}
          />
        </label>
        {errors.is_active && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.is_active}</p>}
      </div>

      <div className='p-1 m-1' style={{ flexGrow: 1 }}>
        <label className="mb-2" style={{ width: "100%" }}>
          Billing Account {userDetails.billing_account !== userBeforeEdit.billing_account && <span>(original value: <i>{userBeforeEdit.billing_account || 'None'}</i>)</span>}
          <input
            className='form-control'
            type="email"
            name="billing_account"
            placeholder="Enter email or leave blank"
            invalid={errors.billing_account}
            value={userDetails.billing_account || ''}
            onChange={(e) => setUserDetails((userDetails) => ({ ...userDetails, [e.target.name]: e.target.value !== '' ? e.target.value : null }))}
          />
        </label>
        {errors.billing_account && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.billing_account}</p>}
      </div>

    </div>

    <div>
      <ul>
        <li>Created at <code>{userDetails.created_at}</code></li>
        <li>Last login <code>{userDetails.last_login && (new Date(Date.parse(userDetails.last_login))).toLocaleString()}</code></li>
        <li>Is admin <code>{userDetails.is_admin !== undefined && (userDetails.is_admin ? 'yes' : 'no')}</code></li>
        <li>Is staff <code>{userDetails.is_staff !== undefined && (userDetails.is_staff ? 'yes' : 'no')}</code></li>
        <li>Email verified <code>{userDetails.email_varify !== undefined && (userDetails.email_varify ? 'yes' : 'no')}</code></li>
        <li>
          <div>Accounts billing this account:</div>
          <ul>
            {(userDetails.billed_accounts && userDetails.billed_accounts.length) > 0 ? (
              userDetails.billed_accounts.map((acc) => (<li key={acc}><code>{acc}</code></li>))
            ) : (
              <li>No accounts bill this account.</li>
            )}
          </ul>
        </li>
      </ul>
    </div>

    <div className='p-1 m-1'>
      {errors.form && <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.form}</p>}
      <button
        className='btn btn-primary'
        disabled={!userDetails.user_id || isLoading}
        onClick={submitEdit}
      >
        Save
      </button>
    </div>
  </>)
};

const Reservations = ({ auth, dispatch, isLoading, setIsLoading, doUpdate, user_id }) => {
  const [data, setData] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const fetchData = async (user_id) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/reservations", "post",
        { user_id: auth.userDeatils.user_id, target_user_id: user_id }
      );
      if (!response.status) throw Error(response.message);
      setData(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsLoading(false);
    }

  }

  useEffect(() => {
    if (user_id === null)
      setData(null);
    else
      fetchData(user_id);
  }, [doUpdate]);

  if (!data || data.length === 0) { return <p style={{ color: "#777", fontStyle: "italic" }}>No reservations available.</p>; }

  const totalReservations = data.length;

  const totalUptimeSeconds = data.reduce((sum, r) => {
    if (!r.sessions) return sum;
    return (
      sum +
      r.sessions.reduce((sSum, s) => sSum + (s.uptime || 0), 0)
    );
  }, 0);

  const totalReservedTime = data.reduce((sum, r) => sum + (r.duration || 0), 0) * 60;


  const zeroSessions = data.filter((r) => !r.sessions || r.sessions.length === 0).length;

  const failedReservations = data.filter(
    (r) =>
      r.sessions &&
      r.sessions.length > 0 &&
      r.sessions.every((s) => s.state === "Failed")
  ).length;

  const withAnyMarker = data.filter((r) => {
    if (!r.sessions || r.sessions.length === 0) return true; // yellow warning
    const allFailed = r.sessions.every((s) => s.state === "Failed");
    const last = r.sessions[r.sessions.length - 1];
    return (
      allFailed ||
      r.sessions.length > 1 ||
      ["Closed", "Running"].includes(last.state)
    );
  }).length;

  const formatDuration = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}h ${m}m ${s}s`;
  };

  const groupedByDate = data.reduce((acc, res) => {
    acc[res.date] = acc[res.date] || [];
    acc[res.date].push(res);
    return acc;
  }, {});

  const thisYear = new Date().getFullYear();
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("nl-NL", {
      day: "numeric",
      weekday: "long",
      month: "long",
      year: date.getFullYear() === thisYear ? undefined : "numeric",
    });
  };

  const formatTime = (timeStr) =>
    new Date(timeStr).toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });

  const formatDateTime = (timeStr) =>
    new Date(timeStr).toLocaleString("nl-NL", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  const getStatusIcon = (sessions) => {
    if (!sessions || sessions.length === 0) {
      return <i className="fa fa-exclamation-triangle" style={{ ...iconStyle, color: "#facc15" }} title="No sessions"></i>;
    }

    const allFailed = sessions.every((s) => s.state === "Failed");
    if (allFailed) {
      return <i className="fa fa-exclamation-circle" style={{ ...iconStyle, color: "#ef4444" }} title="All sessions failed"></i>;
    }

    const lastSession = sessions[sessions.length - 1];
    if (sessions.length === 1 && ["Closed", "Running"].includes(lastSession.state)) {
      return <i className="fa fa-check-circle" style={{ ...iconStyle, color: "#22c55e" }} title="Session successful"></i>;
    }

    if (lastSession.state === "Closed") {
      return <i className="fa fa-exclamation-triangle" style={{ ...iconStyle, color: "#facc15" }} title="Last session closed, multiple sessions"></i>;
    }

    return <i className="fa fa-exclamation-triangle" style={{ ...iconStyle, color: "#facc15" }} title="Session warning"></i>;
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", marginTop: "10px", padding: "1rem" }}>
      <style>
        {`
          .overview {
            background: #eef2f7;
            border: 1px solid #cbd5e1;
            border-radius: 10px;
            padding: 12px 16px;
            margin-bottom: 18px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
          }
          .overview-item {
            font-size: 14px;
            color: #1f2937;
          }
          .overview-item strong {
            color: #111827;
          }
          .reservation-card {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 10px 14px;
            margin: 6px 0;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05);
            transition: box-shadow 0.2s ease;
            cursor: pointer;
          }
          .reservation-card:hover {
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          }
          .reservation-date {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 6px;
          }
          .reservation-time {
            display: flex;
            align-items: center;
            color: #374151;
            font-size: 14px;
          }
          .reservation-right {
            display: flex;
            align-items: center;
          }
          .duration {
            display: flex;
            align-items: center;
            color: #6b7280;
            font-size: 13px;
          }
          .detail-box {
            background: #f3f4f6;
            border-left: 3px solid #3b82f6;
            border-radius: 8px;
            margin: 6px 0 12px 0;
            padding: 10px 14px;
            font-size: 13px;
          }
          .detail-label {
            font-weight: 600;
            color: #374151;
          }
          .session-box {
            background: #fff;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            margin: 6px 0;
            padding: 8px 10px;
          }
        `}
      </style>

      <div className="overview">
        <div className="overview-item">
          <strong>Total reservations:</strong> {totalReservations}
        </div>
        <div className="overview-item">
          <strong>Total reserved time:</strong> {formatDuration(totalReservedTime)}
        </div>
        <div className="overview-item">
          <strong>Total runtime:</strong> {formatDuration(totalUptimeSeconds)}
        </div>
        <div className="overview-item">
          <strong>Unused reservations:</strong> {zeroSessions}
        </div>
        <div className="overview-item">
          <strong>With an issue:</strong> {withAnyMarker}
        </div>
        <div className="overview-item">
          <strong>Failed reservations:</strong> {failedReservations}
        </div>
      </div>

      {Object.entries(groupedByDate).map(([date, reservations], idx) => (
        <div key={date}>
          {idx !== 0 && <hr />}
          <div className="reservation-date">{formatDate(date)}</div>

          {reservations
            .sort((a, b) => new Date(a.time_start) - new Date(b.time_start))
            .map((res, idx) => {
              const globalIndex = `${date}-${idx}`;
              const isExpanded = expandedIndex === globalIndex;
              return (
                <div key={globalIndex}>
                  <div className="reservation-card" onClick={() => toggleExpand(globalIndex)}>
                    <div className="reservation-time">
                      <i
                        className="fa fa-clock-o"
                        style={{ color: "#3b82f6", fontSize: "14px", marginRight: "6px" }}
                      ></i>
                      <span>
                        {formatTime(res.time_start)} - {formatTime(res.time_end)}
                      </span>
                    </div>

                    <div className="reservation-right">
                      <div className="duration" style={{ marginRight: "8px" }}>
                        <i
                          className="fa fa-hourglass-half"
                          style={{ color: "#9ca3af", fontSize: "14px", marginRight: "4px" }}
                        ></i>
                        {res.duration} min
                      </div>
                      {getStatusIcon(res.sessions)}
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="detail-box">
                      <div>
                        <span className="detail-label">ID:</span> {res.id}
                      </div>
                      <div>
                        <span className="detail-label">Created at:</span>{" "}
                        {res.created_at ? formatDateTime(res.created_at) : "N/A"}
                      </div>

                      {res.sessions && res.sessions.length > 0 ? (
                        <div style={{ marginTop: "8px" }}>
                          <div className="detail-label" style={{ marginBottom: "4px" }}>
                            Sessions:
                          </div>
                          {res.sessions.map((s, si) => (
                            <div key={si} className="session-box">
                              <div>
                                <span className="detail-label">State:</span> {s.state}
                              </div>
                              <div>
                                <span className="detail-label">Start:</span>{" "}
                                {formatDateTime(s.time_start)}
                              </div>
                              <div>
                                <span className="detail-label">Stop:</span>{" "}
                                {formatDateTime(s.time_stop)}
                              </div>
                              <div>
                                <span className="detail-label">Uptime:</span> {s.uptime} sec
                              </div>
                              <div>
                                <span className="detail-label">Worker name:</span>{" "}
                                {s.worker_name || "—"}
                              </div>
                              <div>
                                <span className="detail-label">Worker provider:</span>{" "}
                                {s.worker_provider || "—"}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ marginTop: "8px" }}>No session data available.</div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

const Purchases = ({ auth, dispatch, isLoading, setIsLoading, doUpdate, user_id }) => {
  const [data, setData] = useState({});
  const [query, setQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [orderBy, setOrderBy] = useState(['created_at', 'desc']);
  const [orderByField, orderByMethod] = orderBy;

  const fetchData = async (user_id) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/purchases", "post",
        {
          user_id: auth.userDeatils.user_id,
          target_user_id: user_id,
          order_by_field: orderByField,
          order_by_method: orderByMethod,
          search_value: query,
          page: currentPage,
          page_size: 10,
        }
      );
      if (!response.status) throw Error(response.message);
      setData(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user_id === null)
      setData({});
    else
      fetchData(user_id);
  }, [doUpdate, query, orderBy, currentPage]);

  const OrderByArrow = (field) => (
    <img src={field == orderByField ? (orderByMethod === 'asc' ? ascArrow : descArrow) : Arrow} />
  )
  const toggleOrderBy = (field) => {
    setOrderBy(
      ([
        orderByField,
        orderByMethod
      ]) => ([
        field,
        (orderByField == field && orderByMethod == 'asc') ? 'desc' : 'asc'
      ])
    );
  };

  return (<>
    <div className="card-header bg-white d-flex align-items-center justify-content-between">
      <div className="search-col">
        <span className="input-group-text" id="basic-addon1">
          <i className="fa fa-search"></i>
        </span>
        <input
          type="text"
          name="search_value"
          id="search_value"
          className="form-control"
          placeholder="Search..."
          value={query}
          onChange={(e) => { setQuery(e.target.value) }}
        />
      </div>
    </div>
    <div className="card-body" style={{ minWidth: "500px" }}>
      <div className="animation-thead d-flex">
        <div
          className="animation-th w-20 d-flex align-items-center justify-content-between"
          onClick={() => toggleOrderBy('product_name')}
        >
          Plan {OrderByArrow('product_name')}
        </div>
        <div
          className="animation-th w-15 d-flex align-items-center justify-content-between"
          onClick={() => toggleOrderBy("amount_total")}
        >
          Price {OrderByArrow('amount_total')}
        </div>
        <div
          className="animation-th w-15 d-flex align-items-center justify-content-between"
          onClick={() => toggleOrderBy("num_credits")}
        >
          Credit {OrderByArrow('num_credits')}
        </div>
        <div
          className="animation-th w-20 d-flex align-items-center justify-content-between"
          onClick={() => toggleOrderBy("created_at")}
        >
          Date {OrderByArrow('created_at')}
        </div>
        <div
          className="animation-th d-flex align-items-center justify-content-between w-20"
          onClick={() => toggleOrderBy("id")}
        >
          Invoice# {OrderByArrow('id')}
        </div>
        <div className="animation-th d-flex align-items-center justify-content-between w-10">
          Action
        </div>
      </div>
      <div className="animation-tbody">
        {(data.purchases && data.purchases.length > 0) ? (
          data.purchases.map((row, index) => (
            <div
              key={index}
              className="animation-tr d-flex align-items-center"
            >
              <div className="animation-td w-20">
                {row.subscription_plan_name}
              </div>
              <div className="animation-td w-15">
                €{Math.floor(row.subscription_plan_price * 0.01)}.{(row.subscription_plan_price % 100).toString().padStart(2, '0')}
              </div>
              <div className="animation-td w-15">
                {row.number_coin ? row.number_coin : ""}
              </div>
              <div className="animation-td w-20">
                {moment(row.created_at).local().format("MMM D, YYYY hh:mm A")}
              </div>
              <div className="animation-td w-20">
                {row.id}
              </div>
              <div className="animation-td history-status-col w-10">
                <a
                  className="animation-status"
                  style={{
                    backgroundColor: "#1c5db4",
                    cursor: "pointer",
                  }}
                  title="Download invoice"
                  href={`${row.pdf_url}?download=true`}
                >
                  <i
                    className="fa fa-download"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
          ))
        ) : (
          <div className="animation-tr d-flex align-items-center">
            <div className="animation-td animation-col">
              No Records Found.
            </div>
          </div>
        )}
        <PageButtons currentPage={currentPage} setPage={setCurrentPage} numPages={data.num_pages} />
      </div>
    </div>
  </>)
};

const Transactions = ({ auth, dispatch, isLoading, setIsLoading, doUpdate, user_id }) => {
  const [data, setData] = useState({});
  const [query, setQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [orderBy, setOrderBy] = useState(['created_at', 'desc']);
  const [orderByField, orderByMethod] = orderBy;

  const fetchData = async (user_id) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/transactions", "post",
        {
          user_id: auth.userDeatils.user_id,
          target_user_id: user_id,
          order_by_field: orderByField,
          order_by_method: orderByMethod,
          search_value: query,
          page: currentPage,
          page_size: 20,
        }
      );
      if (!response.status) throw Error(response.message);
      setData(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user_id === null)
      setData({});
    else
      fetchData(user_id);
  }, [doUpdate, query, orderBy, currentPage]);

  const OrderByArrow = (field) => (
    <img src={field == orderByField ? (orderByMethod === 'asc' ? ascArrow : descArrow) : Arrow} />
  )
  const toggleOrderBy = (field) => {
    setCurrentPage(1);
    setOrderBy(
      ([
        orderByField,
        orderByMethod
      ]) => ([
        field,
        (orderByField == field && orderByMethod == 'asc') ? 'desc' : 'asc'
      ])
    );
  };

  return (<>
    <div className="card-header bg-white d-flex align-items-center justify-content-between">
      <div className="search-col">
        <span className="input-group-text" id="basic-addon1">
          <i className="fa fa-search"></i>
        </span>
        <input
          type="text"
          name="search_value"
          id="search_value"
          className="form-control"
          placeholder="Search..."
          value={query}
          onChange={(e) => { setQuery(e.target.value); setCurrentPage(1); }}
        />
      </div>
    </div>
    <table className="card-body" style={{display: "table"}}>
      <tbody className="animation-tbody">
        <tr className="animation-thead">
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy("created_at")}
          >
            {OrderByArrow('created_at')} Date
          </th>
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy('id')}
          >
            {OrderByArrow('id')} ID
          </th>
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy('type')}
          >
            {OrderByArrow('type')} Type
          </th>
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy("coin")}
          >
            {OrderByArrow('coin')} #Credits
          </th>
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy("reference_type")}
          >
            {OrderByArrow('reference_type')} Reference Type
          </th>
          <th
            className="animation-th align-items-center justify-content-between"
            onClick={() => toggleOrderBy("reference_id")}
          >
            {OrderByArrow('reference_id')} Reference ID
          </th>
        </tr>
        {(data.transactions && data.transactions.length > 0) ? (
          data.transactions.map((row, index) => (
            <tr
              key={index}
              className="animation-tr align-items-center"
            >
              <td className="animation-td">
                {moment(row.created_at).local().format("MMM D, YYYY hh:mm A")}
              </td>
              <td className="animation-td">
                {row.id}
              </td>
              <td className="animation-td">
                {row.type}
              </td>
              <td className="animation-td">
                {row.coin}
              </td>
              <td className="animation-td">
                {row.reference_type}
              </td>
              <td className="animation-td">
                {row.reference_id}
              </td>
            </tr>
          ))
        ) : (
          <tr className="animation-tr align-items-center">
            <td colSpan={99}>
              No Records Found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
    <PageButtons currentPage={currentPage} setPage={setCurrentPage} numPages={data.num_pages} />
  </>)
};

const Templates = ({ auth, dispatch, isLoading, setIsLoading, doUpdate, user_id }) => {
  const [data, setData] = useState(null);

  const fetchData = async (user_id) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await AxiosApi.withToken(
        auth.accessToken,
        "admin/user/templates", "post",
        { user_id: auth.userDeatils.user_id, target_user_id: user_id }
      );
      if (!response.status) throw Error(response.message);
      setData(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsLoading(false);
    }

  }

  useEffect(() => {
    if (user_id === null)
      setData(null);
    else
      fetchData(user_id);
  }, [doUpdate]);

  if (!data || data.length === 0) { return <p style={{ color: "#777", fontStyle: "italic" }}>No templates available.</p>; }

  const total = data.length;
  const valid = data.filter(
    (p) => p.is_valid && p.preview_state === "Done"
  ).length;
  const used = data.filter((p) => p.num_reservations > 0).length;
  const morphing = data.filter((p) => p.enable_morphing).length;
  const deleted = data.filter((p) => p.is_deleted).length;

  const formatDateTime = (timeStr) =>
    new Date(timeStr).toLocaleString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const getStatusText = (profile) => {

    if (profile.is_deleted) {
      return (
        <div>
          <i className="fa fa-trash" style={{...iconStyle, color: "#8888bb"}}></i>
          This template is <strong>deleted</strong>.
        </div>
      );
    }

    if (!profile.is_valid) {
      return (
        <div>
          <i className="fa fa-exclamation-triangle" style={{...iconStyle, color: "#facc15"}}></i>
          This template is marked <strong>invalid</strong>.
        </div>
      );
    }

    if (profile.preview_state === "Failed") {
      return (
        <div>
          <i className="fa fa-exclamation-circle" style={{...iconStyle, color: "#ef4444"}}></i>
          The <strong>preview generation failed</strong>.
        </div>
      );
    }

    if (["None", "Running"].includes(profile.preview_state)) {
      return (
        <div>
          <i className="fa fa-exclamation-triangle" style={{...iconStyle, color: "#facc15"}}></i>
          The preview is <strong>pending or incomplete</strong>.
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", marginTop: "10px" }}>
      <style>
        {`
          .overview {
            background: #eef2f7;
            border: 1px solid #cbd5e1;
            border-radius: 10px;
            padding: 12px 16px;
            margin-bottom: 18px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
          }
          .overview-item {
            font-size: 14px;
            color: #1f2937;
          }
          .overview-item strong {
            color: #111827;
          }
          .profile-card {
            display: flex;
            align-items: center;
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px;
            margin: 8px 0;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05);
            transition: box-shadow 0.2s ease;
          }
          .profile-card:hover {
            box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          }
          .profile-image-wrapper {
            width: 64px;
            height: 64px;
            margin-right: 14px;
          }
          .profile-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
            border: 1px solid #d1d5db;
            background-color: #666666ff;
          }
          .profile-info {
            display: flex;
            flex-direction: column;
          }
          .profile-info div {
            font-size: 14px;
            color: #374151;
            margin-bottom: 2px;
          }
          code {
            background: #e5e7eb;
            padding: 2px 4px;
            border-radius: 4px;
            font-size: 13px;
          }
        `}
      </style>

      {/* Overview section */}
      <div className="overview">
        <div className="overview-item">
          <strong>Total:</strong> {total}
        </div>
        <div className="overview-item">
          <strong>Valid templates:</strong> {valid}
        </div>
        <div className="overview-item">
          <strong>Used in reservations:</strong> {used}
        </div>
        <div className="overview-item">
          <strong>Morphing enabled:</strong> {morphing}
        </div>
        <div className="overview-item">
          <strong>Deleted:</strong> {deleted}
        </div>
      </div>

      {data.map((profile, index) => (
        <div key={index} className="profile-card">
          <div className="profile-image-wrapper">
            <img src={personIcon} alt="Profile" className="profile-image" />
          </div>

          <div className="profile-info">
            <div>
              <strong>Created at:</strong> {formatDateTime(profile.created_at)}
            </div>
            <div>
              <strong>ID:</strong> <code>{profile.id}</code>
            </div>
            <div>
              Used in <strong>{profile.num_reservations}</strong> reservation
              {profile.num_reservations !== 1 ? "s" : ""}
            </div>
            {profile.enable_morphing && <div>
              <div>
                <i className="fa fa-microphone" style={{...iconStyle, color: "#8b4513"}}></i>
                Audio morphing template
              </div>
            </div>}
            {getStatusText(profile)}
          </div>
        </div>
      ))}
    </div>
  );
};

const UserManager = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [doUpdateModal, setDoUpdateModal] = useState({});
  const [selectedTab, setSelectedTab] = useState('userDetails');

  const updateTab = (tabKey) => {
    setDoUpdateModal((doUpdateModal) => ({ ...doUpdateModal, [tabKey]: !doUpdateModal[tabKey] }));
  }

  const openTab = (tabKey) => {
    updateTab(tabKey);
    setSelectedTab(tabKey);
  }

  const onSelectUser = (user_id) => {
    setSelectedUser(user_id);
    updateTab(selectedTab);
  }

  return (
    <>
      <PageTitle title="DeepTherapy | Users manager" />
      <div className="virtualization">
        <div className="card w-100">
          <div className="card-body">

            <UserSearch auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading} onSelectUser={onSelectUser} />

            <div style={{ display: selectedUser === null ? 'none' : '', opacity: isLoading ? .5 : 1. }}>
              <Tabs
                activeKey={selectedTab}
                onSelect={openTab}
                className="mt-4"
              >

                <Tab
                  eventKey="userDetails"
                  title="User Info"
                >
                  <UserDetails
                    auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading}
                    doUpdate={doUpdateModal.userDetails}
                    user_id={selectedUser}
                  />
                </Tab>

                <Tab
                  eventKey="userReservations"
                  title="Recent Reservations"
                >
                  <Reservations
                    auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading}
                    doUpdate={doUpdateModal.userReservations}
                    user_id={selectedUser}
                  />
                </Tab>

                <Tab
                  eventKey="userPurchases"
                  title="Purchases"
                >
                  <Purchases
                    auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading}
                    doUpdate={doUpdateModal.userPurchases}
                    user_id={selectedUser}
                  />
                </Tab>

                <Tab
                  eventKey="userTransactions"
                  title="Transactions"
                >
                  <Transactions
                    auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading}
                    doUpdate={doUpdateModal.userTransactions}
                    user_id={selectedUser}
                  />
                </Tab>

                <Tab
                  eventKey="userTemplates"
                  title="Templates"
                >
                  <Templates
                    auth={auth} dispatch={dispatch} isLoading={isLoading} setIsLoading={setIsLoading}
                    doUpdate={doUpdateModal.userTemplates}
                    user_id={selectedUser}
                  />
                </Tab>

              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManager;
